/**
 * Zustimmung zu AGB, Datenschutzerklärung und AVV.
 *
 * Bewusst EINE gemeinsame Komponente für alle Registrierungspfade (E-Mail/Passwort
 * und Google), damit der Wortlaut nicht auseinanderläuft: Die AVV-Seite sagt zu,
 * dass die Zustimmung über die Bestätigung einer Checkbox erfolgt — das muss für
 * jeden Pfad gelten, sonst ist der gespeicherte Nachweis (avv_accepted_at,
 * terms_accepted_at) nicht gedeckt. Siehe CAN-33.
 */
type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Eindeutige ID, falls mehrere Instanzen gleichzeitig im DOM stehen */
  id?: string;
  /** 'light' für weiße Karten (Registrierungs-Modal), 'dark' für den dunklen Login-Hintergrund */
  variant?: 'light' | 'dark';
};

export default function ConsentCheckbox({ checked, onChange, id = 'consent-check', variant = 'light' }: Props) {
  const labelClass = variant === 'dark' ? 'text-xs text-[#9B8FBB] leading-relaxed cursor-pointer' : 'text-xs text-gray-500 leading-relaxed cursor-pointer';
  const linkClass = variant === 'dark' ? 'text-[#FF9A00] underline hover:text-[#FF6D00]' : 'text-[#FF6D00] underline hover:text-[#e05c00]';

  return (
    <div className="flex items-start gap-2.5 pt-1">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className="mt-0.5 w-4 h-4 accent-[#FF6D00] cursor-pointer flex-shrink-0"
        required
      />
      <label htmlFor={id} className={labelClass}>
        Ich habe die{' '}
        <a href="/agb" target="_blank" rel="noreferrer" className={linkClass}>AGB</a>{' '}
        und die{' '}
        <a href="/datenschutz" target="_blank" rel="noreferrer" className={linkClass}>Datenschutzerklärung</a>{' '}
        gelesen und stimme dem{' '}
        <a href="/avv" target="_blank" rel="noreferrer" className={linkClass}>Auftragsverarbeitungsvertrag (AVV)</a>{' '}
        zu.
      </label>
    </div>
  );
}
